import script from "./DrgDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrgDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./DrgDisplay.vue?vue&type=style&index=0&id=02d8aba4&lang=scss"

const __exports__ = script;

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton,QSpace,QBtn,QIcon,QTooltip,QChip});
